<template>
  <div class="language-switcher">
    <div class="language-dropdown">
      <div class="current-language">
        <span>{{ currentLanguageLabel }}</span>
        <span class="language-divider">|</span>
        <span class="switch-language" @click="switchToAlternateLanguage">{{ alternateLanguageLabel }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LanguageSwitcher',
  data() {
    return {
      isDropdownOpen: false,
      languages: [
        { code: 'zh', name: '切换中文', flag: '🇨🇳' },
        { code: 'en', name: '切换English', flag: '🇺🇸' }
      ]
    }
  },
  computed: {
    currentLanguage() {
      return this.$i18n.locale
    },
    currentLanguageLabel() {
      const current = this.languages.find(lang => lang.code === this.currentLanguage)
      return current ? current.name : '中文'
    },
    alternateLanguageLabel() {
      const alternate = this.languages.find(lang => lang.code !== this.currentLanguage)
      return alternate ? alternate.name : 'English'
    }
  },
  mounted() {
    // 点击外部关闭下拉菜单
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    switchToAlternateLanguage() {
      const alternate = this.languages.find(lang => lang.code !== this.currentLanguage)
      if (alternate) {
        this.switchLanguage(alternate.code)
      }
    },
    switchLanguage(langCode) {
      this.$i18n.locale = langCode
      localStorage.setItem('language', langCode)
      this.$emit('language-changed', langCode)
    },
    handleClickOutside() {
      // 保留此方法以防将来需要
    }
  }
}
</script>

<style scoped>
.language-switcher {
  position: relative;
  z-index: 1000;
}

.language-dropdown {
  position: relative;
  cursor: pointer;
}

.current-language {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
  color: white;
  font-weight: 500;
  min-width: 120px;
}

.language-divider {
  color: rgba(255, 255, 255, 0.5);
  margin: 0 4px;
}

.switch-language {
  color: black;
  cursor: pointer;
  transition: all 0.2s ease;
}

.switch-language:hover {
  color: black;
  /* text-decoration: underline; */
}

.current-language:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.3);
}

.language-icon {
  font-size: 16px;
}

.dropdown-arrow {
  margin-left: auto;
  font-size: 12px;
  transition: transform 0.3s ease;
}

.dropdown-arrow.dropdown-open {
  transform: rotate(180deg);
}

.language-options {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  margin-top: 4px;
  overflow: hidden;
  animation: fadeInDown 0.3s ease;
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.language-option {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  color: #333;
  transition: background-color 0.2s ease;
  cursor: pointer;
}

.language-option:hover {
  background: rgba(76, 175, 80, 0.1);
}

.language-option.active {
  background: rgba(76, 175, 80, 0.2);
  color: #2E7D32;
  font-weight: 600;
}

.language-flag {
  font-size: 16px;
}

.language-name {
  font-size: 14px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .current-language {
    min-width: 100px;
    padding: 6px 12px;
  }
  
  .language-option {
    padding: 10px 12px;
  }
}
</style>
